'use client'

import React from 'react'

import { IOtaAppContext, OtaAppContext } from './OtaAppContext'

export const OtaAppContextProvider = ({
  children,
  isOta,
}: {
  children: React.ReactNode
  isOta: boolean
}) => {
  const context: IOtaAppContext = {
    isOta,
  }

  return (
    <OtaAppContext.Provider value={context}>{children}</OtaAppContext.Provider>
  )
}
